import React, {Component} from 'react'
import { Switch, Route } from 'react-router-dom'
import {graphql} from 'react-apollo'
import PropTypes from 'prop-types'
import {RiseLoader} from 'react-spinners'
import ProjectDefectiveness from './ProjectDefectiveness'
import WelderDefectiveness from './WelderDefectiveness'
import { ProjectsFetchQueryWithInspectionsDict } from './query'

class Defectiveness extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  static propTypes = {
    data: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  render() {
    if (this.props.data.loading) {
      return (
        <div className="spinner-item" id="loader-bg">
          <RiseLoader color="#20a8d8" loading={true} />
        </div>
      )
    }

    if (this.props.data.error) {
      return (<div>An unexpected error occurred</div>)
    }

    return (
      <div>
        <Switch>
          <Route path="/reports/welder-defectiveness"
            render={()=> <WelderDefectiveness
              location={this.props.location}
              history={this.props.history}
              ProjectsList={this.props.data.projects.list}
              InspectionCategoryTypes={this.props.data.inspection_category_types.filter(o => o.name !== 'RI')}
            />}
          />
          <Route path="/reports/project-defectiveness"
            render={()=> <ProjectDefectiveness
              ProjectsList={this.props.data.projects.list}
              InspectionCategoryTypes={this.props.data.inspection_category_types.filter(o => o.name !== 'RI')}
              CompaniesList={this.props.data.companies ? this.props.data.companies.list : []}
            />}
          />
        </Switch>
      </div>
    )
  }
}

const DefectivenessWithData = graphql(ProjectsFetchQueryWithInspectionsDict, {
  options: () => ({
    fetchPolicy: 'network-only'
  }),
}
)(Defectiveness)

export default DefectivenessWithData



// WEBPACK FOOTER //
// ./src/components/Report/Defectiveness.js